import type { BrandKey } from '@/models/configuration';

export function transformLanguageCode(code: Nullable<string>) {
  switch (code?.toLowerCase()) {
    case 'zh-tw':
      return 'zh-TW';
    case 'vi':
    case 'vi-vn':
      return 'vi-VN';
    case 'zh':
    case 'zh-cn':
      return 'zh-CN';
    default:
      return 'en-US';
  }
}

export const glyphCodes = ['han', 'latin'] as const;

export type GlyphCode = (typeof glyphCodes)[number];

export function transformGlyphCode(code: Nullable<string>): GlyphCode {
  switch (code?.toLowerCase()) {
    case 'en':
    case 'en-us':
    case 'vi':
    case 'vi-vn':
      return 'latin';
    default:
      return 'han';
  }
}

interface Code {
  locale: string;
  glyph: GlyphCode;
  icon: GlyphCode | undefined;
  splashscreens: GlyphCode | undefined;
}

export function getCodeByBrand(key: BrandKey | undefined, code: Nullable<string>): Readonly<Code> {
  switch (key) {
    case 'wangyou':
      return {
        locale: transformLanguageCode(code),
        glyph: transformGlyphCode(code),
        icon: undefined,
        splashscreens: transformGlyphCode(code),
      };
    default:
      return {
        locale: transformLanguageCode(code),
        glyph: transformGlyphCode(code),
        icon: undefined,
        splashscreens: undefined,
      };
  }
}
